export default __webpack_public_path__ + "18ae72e36fe7aeadb2ffba3749bb0a77.png";